"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusMagnetizer = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const constants_1 = require("../../constants");
const CardName_1 = require("../../CardName");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class VenusMagnetizer extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.VENUS_MAGNETIZER,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 7,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.venus(10)),
            metadata: {
                cardNumber: '256',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Decrease your Energy production 1 step to raise Venus 1 step.', (eb) => {
                        eb.production((pb) => pb.energy(1)).startAction.venus(1);
                    });
                }),
                description: 'Requires Venus 10%.',
            },
        });
    }
    ;
    play() {
        return undefined;
    }
    canAct(player) {
        const venusMaxed = player.game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
        const hasEnergyProduction = player.getProduction(Resources_1.Resources.ENERGY) > 0;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = this.getTotalTRGain(player);
        Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise Venus');
        if (!hasEnergyProduction)
            return false;
        if (venusMaxed)
            return true;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.game.increaseVenusScaleLevel(player, 1);
        return undefined;
    }
    getTotalTRGain(player) {
        const venusScale = player.game.getVenusScaleLevel();
        let trGain = venusScale === constants_1.MAX_VENUS_SCALE ? 0 : 1;
        if (venusScale === 14)
            trGain += 1;
        return trGain;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ venusIncrease: 1 });
    }
}
exports.VenusMagnetizer = VenusMagnetizer;
//# sourceMappingURL=VenusMagnetizer.js.map